import { queryOptions } from "@tanstack/react-query";
import { getSettings } from "api-client";

export function settingsQueryOptions() {
  return queryOptions({
    queryKey: ["settings"],
    queryFn: async () => {
      const response = await getSettings();
      return response.data.data;
    },
  });
}
